module.exports = __webpack_public_path__ + "img/com.moji.mjweather.alpha.10741046.png";